module.exports = __webpack_public_path__ + "static/media/vextroai.6e998039.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/vextroai.webp
// module id = 389
// module chunks = 0